module.exports = __webpack_public_path__ + "img/4A.9228f542.png";